import {checkIfKnownGroundBackground} from '../../configs/groundBackgrounds';

/**
 * Выбор подложки поля на странице настройки локальной партии запоминается в
 * localStorage — как скорость хода ботов (см. readHotSeatBotSpeed): игрок,
 * которому нравится одна подложка, не выбирает ее заново перед каждой партией.
 *
 * Значение — идентификатор подложки; «Случайная» хранится отсутствием записи.
 */
export const HOT_SEAT_GROUND_BACKGROUND_LOCAL_STORAGE_KEY = 'hotSeatGroundBackground';

/**
 * Сохраненный выбор подложки. Все, что не годится (записи нет, мусор,
 * подложку с тех пор сняли с раздачи, localStorage недоступен), — null, то
 * есть «Случайная»: незнакомый идентификатор не должен доехать до партии и ее
 * записи
 * @returns {string|null}
 */
export const readHotSeatGroundBackground = () => {
  try {
    const stored = localStorage.getItem(HOT_SEAT_GROUND_BACKGROUND_LOCAL_STORAGE_KEY);
    return checkIfKnownGroundBackground(stored) ? stored : null;
  } catch {
    return null;
  }
};

/**
 * Запомнить выбор подложки; «Случайная» (и все, что подложкой не является)
 * стирает запись
 * @param {string|null} groundBackgroundId
 */
export const writeHotSeatGroundBackground = (groundBackgroundId) => {
  try {
    if (checkIfKnownGroundBackground(groundBackgroundId)) {
      localStorage.setItem(HOT_SEAT_GROUND_BACKGROUND_LOCAL_STORAGE_KEY, groundBackgroundId);
    } else {
      localStorage.removeItem(HOT_SEAT_GROUND_BACKGROUND_LOCAL_STORAGE_KEY);
    }
  } catch {
    // localStorage недоступен (приватный режим и т.п.) — выбор живет до ухода со страницы
  }
};
